/**
* Date  : 2023/11/16
* Author : zhuql
* Declare : index
*/

import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { useRequest } from 'ahooks';

import raysserveapi from '@/api/raysserveapi';
import { Image, Progress, Tooltip } from '@/components/AntD';
import SvgaPlayer from '@/components/SvgaPlayer';

import './index.scss';
import EllipsisTitle from '@/components/EllipsisTitle';

export default function DubWarp() {

  const { data: tabs = [] } = useRequest(() => raysserveapi.getNameList());
  const { data = [], run: getVoicerList } = useRequest((value) => raysserveapi.categoryList(value), { manual: true });
  const audioRef = useRef(null);
  const [itemId, setItemId] = useState(0);

  const [playing, setPlaying] = useState(false);
  const [playInfo, setPlayInfo] = useState({});
  const [percent, setPercent] = useState(0);

  useEffect(() => {
    if(tabs.length) {
      changeTab(tabs[0].categoryId);
    }
  }, [tabs]);

  const changeTab = (value) => {
    setItemId(value);
    const params = {
      'languageId': '',
      'categoryId': value,
      'voicerSex': '',
      'ageGroup': '',
      'query': ''
    };
    getVoicerList(params);
  };

  const changePlay = (value, play) => {
    if(value.id === playInfo.id) {
      play ? audioRef.current.play() : audioRef.current.pause();
    } else {
      audioRef.current.src = value.hiAudioUrl;
      audioRef.current.play();
    }
    setPlaying(play);
    setPlayInfo(value);
  };

  const onTimeUpdate = () => {
    setPercent(Math.floor(audioRef.current.currentTime * 100 / audioRef.current.duration));
  };

  const onEnded = () => {
    setPlaying(false);
    setPlayInfo({});
  };

  return (
    <div className="DubWarp">
      <div className="DubWarp-title">丰富的配音，定制你的<span>专属</span>音色</div>
      <div className="DubWarp-content">
        <div className="left-warp">
          {
            tabs.map((item, index) => {
              return (
                <div onClick={() => changeTab(item.categoryId)} className={classNames('tab-item', { 'active': itemId === item.categoryId })} key={index}>{item.categoryName}</div>
              );
            })
          }
        </div>
        <div className="right-warp">
          <div className="right-warp-scroll">
            {
              data.length && data[0].speakerList.map((item, index) => {
                return (
                  <div className="data-item" key={index}>
                    <div className="item-warp">
                      <div className="item-warp-left">
                        <Image src={item.voicerHeadUrl} width={36} preview={false} />
                        <div className="base-info">
                          <div className="voicerShowName">{item.voicerShowName}</div>
                          {item.languageId !== 1 && item.language && <div className="langName">{item.language}</div>}
                          {/* {!(item.languageId !== 1 && !item.voicerStyle) && <div className="language-desc">{item.voicerStyle}</div>} */}
                          {!(item.languageId !== 1 && !item.voicerStyle) && <EllipsisTitle placement="bottom" className="language-desc style" title={item.voicerStyle} ellipsis={1} />}
                        </div>
                      </div>
                      {
                        playing && item.id === playInfo.id ?
                          <Progress
                            type="circle"
                            percent={percent}
                            width={18}
                            height={18}
                            strokeColor="#006AFF"
                            strokeWidth={10}
                            trailColor="#cce1ff"
                            format={percent => <div onClick={() => changePlay(item, false)} style={{ width: '12px', height: '12px' }}>
                              <SvgaPlayer svgaUrl="https://oss.5rs.me/oss/uploadfe/svga/videoplay.svga" />
                            </div>}
                          /> :
                          <Image className="play-img" onClick={() => changePlay(item, true)} src={PLAY_IMG} width={20} preview={false} />
                      }
                    </div>
                    <Tooltip placement="bottom" title={item.categoryInfo?.length > 4 ? item.categoryInfo.join('|') : '' }>
                      <div className="voicer-scene mt6">
                        {
                          item.categoryInfo && item.categoryInfo.map((label, index) => {
                            return <span key={ index }>{label} {index === (item?.categoryInfo?.length - 1) ? '' : <i className="line" />} </span>;
                          })
                        }
                      </div>
                    </Tooltip>
                  </div>
                );
              })
            }
          </div>
        </div>
      </div>
      <audio ref={audioRef} onTimeUpdate={onTimeUpdate} onEnded={onEnded} />
    </div>
  );
}

const PLAY_IMG = 'https://oss.5rs.me/oss/uploadfe/png/1c4257f91e8701d1b4c7261e62ace52f.png';
